import store from "@/store";
import axios from "axios";
import Vue from 'vue';

/* Axios Instance */
export const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL_API
});

axiosInstance.interceptors.request.use(async function (config) {
  config.headers['Authorization'] = `bearer ${store.getters['User/user']?.token}`;

  store.dispatch("setIsLoading", true, { root: true });

  return config;

});

axiosInstance.interceptors.response.use((response) => {
  store.dispatch("setIsLoading", false, { root: true });

  return response
}, (error) => {
  store.dispatch("setIsLoading", false, { root: true });

  swalError(error)

  throw error;
});

/**
 * added no vue o axios
 */
Vue.prototype.$axiosInstance = axiosInstance;

/**
 * method error
 * @param {*} error
 */
function swalError(error){
  let dataError = error ? error : 'Error is null';
  let message = error.response?.data ? error.response.data : '';

  Vue.swal.fire({
    icon: 'error',
    title: message,
    html: dataError
  })
}
